module.exports = __webpack_public_path__ + "img/duartee-co-logo.4bae3942.jpg";